import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useParams } from 'react-router-dom';

import * as actions from 'containers/ProjectTools/Notes/actions';
import * as noteActions from 'containers/ProjectTools/Notes/Note/actions';
import {
  getProjectFeatures as actionGetProjectFeatures,
  weddingPermissions as actionWeddingPermissions,
} from 'containers/Projects/actions';
import { getSingleProject } from 'containers/ProjectTools/Project/actions';
import {
  getNoteTemplateFolders as actionGetNoteTemplateFolders,
} from 'containers/Settings/Projects/actions';
import { Loading } from 'components/Loading';
import { getGoogleFonts, GOOGLE_FONT_LINK_ID } from 'components/PlateEditor/plugins/fonts/createFontFamilyPlugin';

import NoteEditorComponent from './NoteEditor';
import './note-editor.scss';

const NoteEditor = () => {
  const { noteId, templateId, projectId, category } = useParams();
  const dispatch = useDispatch();

  const isTemplate = !!templateId;
  const isCategory = !!category;
  const currentItem = useSelector((state) =>
    templateId ? state.projectTools.note.template : state.projectTools.note.note);
  const refreshRequired = useSelector((state) => state.projectTools.note.refresh);
  const project = useSelector((state) => state.projectTools.project);
  const weddingPermissions = useSelector(state => state.projects.weddingPermission || []);
  const templateFolders = useSelector((state) => state.settings.projectSettings.noteTemplateFolders);

  const {
    getCurrentNote,
    getCurrentTemplate,
    updateSingleNote,
    updateSingleTemplate,
    blockCurrentNote,
    unBlockCurrentNote,
    fileUpload,
    fileRemove,
    templateFileRemove,
    restrictionsNote,
    createNoteComment,
    updateNoteComment,
    deleteNoteComment,
    closeErrorModal,
    getSingleProject: _getSingleProject,
    getProjectFeatures,
    getWeddingPermissions,
    getNoteTemplateFolders,
  } = bindActionCreators(
    {
      ...actions,
      ...noteActions,
      getSingleProject,
      getProjectFeatures: actionGetProjectFeatures,
      getWeddingPermissions: actionWeddingPermissions,
      getNoteTemplateFolders: actionGetNoteTemplateFolders,
    },
    dispatch,
  );

  const getItem = templateId ? getCurrentTemplate : getCurrentNote;
  const itemId = templateId ?? noteId;

  // This is to differentiate unfetched projects.
  const projectIsEmpty = !project || Object.keys(project).length === 0;

  useEffect(() => {
    if (!templateId && projectIsEmpty) {
      _getSingleProject({ id: projectId });
      getProjectFeatures({ id: projectId });
      // Check if template folders have been fetched and fetch if not.
      if (!templateFolders || templateFolders.length === 0) {
        getNoteTemplateFolders();
      }
    }
    getWeddingPermissions({ weddingId: projectId });

    // Load fonts
    if (!document.getElementById(GOOGLE_FONT_LINK_ID)) {
      getGoogleFonts();
    }
  }, []);

  useEffect(() => {
    if (itemId) {
      getItem({ variables: { id: itemId } });
    }
  }, [itemId]);

  useEffect(() => {
    if (refreshRequired && itemId) {
      getItem({ variables:{ id: itemId } });
    }
  }, [refreshRequired]);

  // Need current item before loading and a loaded project if a note.
  if (!currentItem || (!templateId && projectIsEmpty)) return <Loading />;

  /* #TODO: Add error handling.
  if (projectIsEmpty) {

  }
  */
  const getWeddingPermissionsbyName = (permissionsName) => {
    const index = weddingPermissions.find(p => p.name === permissionsName);
    if(index){
      return index.value;
    }

    return true;
  };

  return (
    <>
      <NoteEditorComponent
        isTemplate={isTemplate}
        isCategory={isCategory}
        category={category}
        itemId={itemId}
        currentItem={currentItem}
        updateItem={isTemplate ? updateSingleTemplate : updateSingleNote}
        blockCurrentNote={blockCurrentNote}
        unBlockCurrentNote={unBlockCurrentNote}
        fileUpload={fileUpload}
        fileRemove={isTemplate ? templateFileRemove : fileRemove}
        restrictionsNote={restrictionsNote}
        createNoteComment={createNoteComment}
        updateNoteComment={updateNoteComment}
        deleteNoteComment={deleteNoteComment}
        closeErrorModal={closeErrorModal}
        notesEdit={getWeddingPermissionsbyName('notes.edit')}
      />
    </>
  );
};

export default NoteEditor;
